<template>
  <div class="app_commonHeader">
    <div :class="sliderBarState ? 'active_logo' : ''" @click="goHome" class="commonLogo"> <svg-icon icon-class="testIcon" :customStyle="svgStyle"/> <span v-if="!sliderBarState">Z-System</span> </div>
    <div class="common_header" :class="sliderBarState ? 'active_header' : ''">
      <div class="icon">
        <span class="menu_button">
          <i @click="toggleSliderBar" :class="!sliderBarState ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
        </span>
        <span>
          <Breadcrumb></Breadcrumb>
        </span>
      </div>
      <div class="right_button">
        <span class="search_button">
          <SearchBar></SearchBar>
        </span>
        <Message></Message>
        <span @click="handleGoBigData">
          <svg-icon class="bigData" icon-class="bigData1" :customStyle="customStyle" />
        </span>
        <span class="line"></span>
        <el-dropdown @command="goAdmain" class="user_admin" trigger="click">
            <span class="el-dropdown-link">
              <span class="user_box">
                <svg-icon icon-class="userimg" :customStyle="svgStyleUser"/>
              </span>
              <!-- <img :src="src" alt style="max-width: 40px; max-height: 40px; vertical-align: middle; margin-right: -8%;"> -->
              <span class="user">{{userInfo.nickName ? userInfo.nickName : pageUserInfos.nickName}}</span>
              <i class="el-icon-arrow-down el-icon--right" style="color:#fff;"></i>
            </span>
          <el-dropdown-menu class="admin_center" slot="dropdown">
            <!-- <el-dropdown-item command="admin">
              <i class="fa fa-user-o"></i>
              <span>Admin</span>
            </el-dropdown-item> -->
            <el-dropdown-item command="loginOut">
              <i class="fa fa-sign-out"></i>
              <span>LogOut</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import svgIcon from 'components/svgIcons'
import { mapGetters, mapActions } from 'vuex'
import Message from '../home/message'
import { getUserInfos, removeUserInfos, removeDBExpIdList, removeInsExpIdList } from 'utils/cache'
import { removeToken } from 'utils/token'
import Breadcrumb from 'components/Breadcrumb'
import SearchBar from '@/components/searchBar'
export default {
  data () {
    return {
      svgStyle: {width: '30px', height: '30px'},
      customStyle: {width: '20px', height: '20px', verticalAlign: 'middle'},
      svgStyleUser: {width: '20px', height: '20px', verticalAlign: 'top', marginTop: '8px'},
      pageUserInfos: {}
    }
  },
  components: {
    svgIcon,
    Message,
    Breadcrumb,
    SearchBar
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'sliderBarState'
    ])
  },
  created () {
    this.pageUserInfos = JSON.parse(getUserInfos())
  },
  methods: {
    ...mapActions([
      'toggleSliderBarState'
    ]),
    toggleSliderBar () {
      this.toggleSliderBarState()
    },
    goHome () {
      this.$router.push('/')
    },
    goAdmain (command) {
      console.log(command)
      switch (command) {
        case 'projectManagement':
          this.$router.push('/project/index')
          break
        case 'dataProcessing':
          this.$router.push('/processing/index')
          break
        case 'admin':
          this.$router.push('/admin')
          break
        case 'setting':
          this.$router.push('/users/personalSettings')
          break
        case 'loginOut':
          removeToken()
          removeUserInfos()
          removeDBExpIdList()
          removeInsExpIdList()
          location.reload()
          break
      }
    },
    handleGoBigData () {
      this.$router.push('/bigData/index')
    }
  }
}
</script>
<style lang="scss" rel="stylesheet/scss" socped>
 @import '../../../styles/variable.scss';
.app_commonHeader {
  height: 60px;
  line-height: 60px;
  .commonLogo {
    overflow: hidden;
    user-select: none;
    cursor: pointer;
    float: left;
    width: 250px;
    background-color: $sliderColor;
    color: #fff;
    text-indent: 22px;
    line-height: 60px;
    font-size: 20px;
    svg {
      line-height: 60px;
      vertical-align: middle;
      margin-top: -6px;
    }
  }
  .commonLogo:hover {
    color: skyblue;
  }
  .common_header {
    float: right;
    height: 60px;
    background-color: #fff;
    width: calc(100% - 250px);
    box-shadow: 0 1px 4px rgba(0,21,41,.2);
    .icon {
      float: left;
      margin-left: 30px;
      .menu_button {
        i {
          font-size: 26px;
          vertical-align: middle;
          cursor:pointer;
          color: #409eff;
        }
      }
    }
    .line {
      height: 30px;
      display: inline-block;
      width: 1px;
      background-color: #c9c8c8;
      vertical-align: middle;
      margin-left: 6px;
    }
    .user_admin {
      // min-width: 140px;
      // border-left: 1px solid #333;
      // margin-left: 8px;
      padding: 0 10px;
      text-align: center;
      cursor: pointer;
      // width: 120px;
    }
    .user {
      margin-left: 4px;
    }
    .user_box {
      position: relative;
      display: inline-block;
      height: 36px;
      width: 36px;
      background-color: skyblue;
      vertical-align: middle;
      border-radius: 100%;
    }
    .right_button {
      float: right;
      line-height: 60px;
      padding: 0 20px;
      .search_button {
        float: left;
        padding-top: 15px;
        i {
          font-size: 20px;
          vertical-align: middle;
          cursor:pointer;
        }
      }
    }
  }
  .active_header {
    width: calc(100% - 64px);
  }
  .active_logo {
    width: 64px;
    text-indent: 0;
    text-align: center;
  }
}
.bigData {
  cursor: pointer;
}
</style>
<style lang="scss">
  .admin_center {
    width: 120px;
    padding: 10px 10px;
    // text-align: left;
    .el-dropdown-menu__item {
      line-height: 30px;
      font-size: 12px;
    }
    .line {
      height: 1px;
      margin: 6px 0;
      background-color: #cfcfcf;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/firmiana/layout/commonHeader.vue